import { render, staticRenderFns } from "./workorder-info-panel.vue?vue&type=template&id=ec06bd90&"
import script from "./workorder-info-panel.vue?vue&type=script&lang=js&"
export * from "./workorder-info-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports